export const OPEN_CRITERIA_WHEN_EVENT = 'openCriteriaWhen';
